import { topicsData } from '@/mocks/home';

export default function SectionTopics() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '4rem' }}>
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-foreground-950 mb-2">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500">瓜友们正在热议的焦点话题</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, i) => (
            <div
              key={i}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-colors whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100 text-primary-700'
                  : 'bg-background-50 border-background-200 hover:bg-background-100 text-foreground-600'
              }`}
            >
              <span className="text-sm font-medium">{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-primary-500' : 'text-foreground-400'}`}>{topic.count}</span>
              {topic.hot && <i className="ri-fire-fill text-accent-500 text-xs"></i>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}